module.exports = __webpack_public_path__ + "static/media/link.acd36c44.svg";